import React from 'react';
import { FormattedMessage } from 'react-intl';
import pick from 'lodash/pick';
import filter from 'lodash/filter';

export const getCountryLabelAndZones = (allCountries, selectedCountryCode) => {
  const selectedCountry =
    filter(allCountries, ['code', selectedCountryCode])[0] || {};
  return pick(selectedCountry, ['labels', 'zones']);
};

export const addressFormErrors = {
  selectCountry: (
    <FormattedMessage
      id="bkg.billing_address_form_errors.enter_country"
      defaultMessage="Please select a country"
    />
  ),
  enterStreetAddress: (
    <FormattedMessage
      id="bkg.billing_address_form_errors.enter_street_address"
      defaultMessage="Please enter a street address"
    />
  ),
  enterCity: {
    Area: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_area"
        defaultMessage="Please enter an area"
      />
    ),
    City: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_city"
        defaultMessage="Please enter a city"
      />
    ),
    'City/town': (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_city_town"
        defaultMessage="Please enter a city/town"
      />
    ),
    'City/ward/town/village': (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_city_ward_town_village"
        defaultMessage="Please enter a city/ward/town/village"
      />
    ),
    District: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_district"
        defaultMessage="Please enter a district"
      />
    ),
    Suburb: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_suburb"
        defaultMessage="Please enter a suburb"
      />
    ),
    Ward: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_ward"
        defaultMessage="Please enter a ward"
      />
    )
  },
  enterValidPostalCode: {
    'PIN code': (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_valid_pin_code"
        defaultMessage="Please enter a valid PIN code"
      />
    ),
    'Postal code': (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_valid_postal_code"
        defaultMessage="Please enter a valid postal code"
      />
    ),
    Postcode: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_valid_post_code"
        defaultMessage="Please enter a valid post code"
      />
    ),
    'ZIP code': (
      <FormattedMessage
        id="bkg.billing_address_form_errors.enter_valid_zip_code"
        defaultMessage="Please enter a valid zip code"
      />
    )
  },
  selectState: {
    Country: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_country"
        defaultMessage="Please select a country"
      />
    ),
    County: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_county"
        defaultMessage="Please select a county"
      />
    ),
    Emirate: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_emirate"
        defaultMessage="Please select an emirate"
      />
    ),
    Governorate: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_governorate"
        defaultMessage="Please select a governorate"
      />
    ),
    Prefecture: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_prefecture"
        defaultMessage="Please select a prefecture"
      />
    ),
    Province: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_province"
        defaultMessage="Please select a province"
      />
    ),
    Region: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_region"
        defaultMessage="Please select a region"
      />
    ),
    State: (
      <FormattedMessage
        id="bkg.billing_address_form_errors.select_state"
        defaultMessage="Please select a state"
      />
    ),
    'State/territory': (
      <FormattedMessage
        id="bkg.billing_address_form_errors.state_territory"
        defaultMessage="Please select a state/territory"
      />
    )
  }
};
